import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';
import API from '../api/api';
import './style/EditCommentForm.css';

class EditCommentForm extends React.Component {
    static propTypes = {
        onClose: PropTypes.func,
        boat: PropTypes.string,
        date: PropTypes.object,
        slot: PropTypes.string,
        comment: PropTypes.string
    }
    state = {
        code: '',
        comment: ''
    }
    constructor(props) {
        super(props);
        this.focused = false;
    }
    componentWillMount() {
        this.setState({comment: this.props.comment});
    }
    render() {
        let submitEnabled = !isEmpty(this.state.code);
        return (
            <form className="edit-comment-form" action="" onSubmit={this.submit}>
                <div>
                    <textarea ref={this.checkFocus} name="comment" value={this.state.comment} onChange={ev => this.setState({comment: ev.target.value})}></textarea>
                </div>
                <div><i>Il campo può essere unicamente salvato dal membro che ha effettuato la prenotazione</i></div>
                <div>
                    <span>ID:</span>
                    <input type="text" placeholder={"Indicato sulla tessera membro"} value={this.state.code} onChange={ev => this.setState({code: ev.target.value.toLowerCase()})} />
                    <button type="submit" disabled={!this.state.code}>Salva</button>
                    <button onClick={ev => this.props.onClose(false)} type="button">Annulla</button>
                </div>
            </form>
        );
    }
    checkFocus = (el) => {
        if(el && !this.focused) {
            el.focus();
            el.selectionStart = el.selectionEnd = el.value.length;
            this.focused = true;
        }
    }
    submit = (ev) => {
        ev.preventDefault();
        API.editComment(this.props.boat, this.props.date, this.props.slot, this.state.comment, this.state.code, (success, data) => {
            if(success) {
                this.props.onClose(true);
            } else {
                alert(data);
            }
        });
    }
};

export default EditCommentForm;
